<div style="margin-top:5px;padding:0px !important">
    <div class="field mb-4 col-12" id="confToPrint">
        <div style="width:100%" [innerHTML]="confHTML | safe: 'html'">
        </div>
    </div>
  </div>